import { Button, Tooltip } from 'flowbite-react';
import { useEffect, useState } from 'react';
import UserListTable from './UserListTable';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { User } from '../../Models/User';
import { useAppSelector } from '../../Reducers/store';
import AddUserModal from './AddUserModal';
import { UserLevelNames } from '../../Models/UserLevel';
import { useParams } from 'react-router-dom';
import UserApi from '../../Api/UserApi';
import { HiPlus } from 'react-icons/hi';

export default function UserList() {
  const { id } = useParams();
  const { userModel } = useAppSelector((state) => state.user);
  const [userListData, setUserListData] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddUser, setShowAddUser] = useState<boolean>(false);

  useEffect(() => {
    getUsers();
  }, [userModel]);

  const getUsers = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return UserApi.getUserList()
          .then((res) => {
            setUserListData(res.data);

            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  };

  const handleAddUserClick = () => {
    setShowAddUser(true);
  };

  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>User List</div>
              </h1>
            </div>
            {checkAccess() && (
              <div className=''>
                <Tooltip content='Add User'>
                  <Button onClick={handleAddUserClick} className='buttonMain'>
                    <HiPlus size={20} />
                  </Button>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
            {!isLoading && userListData.length === 0 ? (
              <div className='text-center text-gray-500 py-20'>
                No users found.
              </div>
            ) : (
              <UserListTable data={userListData} />
            )}
          </div>
        </div>
      </div>
      <AddUserModal show={showAddUser} setShow={setShowAddUser}></AddUserModal>
    </>
  );
}
